import EditPersonalInfoLightboxContainer from './EditPersonalInfoLightboxContainer';

export default EditPersonalInfoLightboxContainer;
